import axios from "axios";

export function apiGetMobilities(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS + "api/mobilities" + (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetMobility(instance, id) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/mobilities/" + id, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveMobility(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/mobilities", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return error.response;
    });
}

export function apiUpdateMobility(id, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/mobilities/" + id, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteMobility(id) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/mobilities/" + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
